import script from "./SubastaUbicaciones.vue?vue&type=script&setup=true&lang=js"
export * from "./SubastaUbicaciones.vue?vue&type=script&setup=true&lang=js"

import "./SubastaUbicaciones.vue?vue&type=style&index=0&id=0c5e1c7e&lang=css"

const __exports__ = script;

export default __exports__